import { portalApi } from "./client";

// TPS Servicing Portal PR-H — portal-side client + DTO types for the firm's
// "Collections" surface (its LinkedTpsId-scoped default/collection cases).
// Mirrors the C# records the backend exposes under /api/portal/tps/collections.
// Kept inside the portal bundle so nothing here imports staff types. No React
// Query in the portal — callers load with useState and re-run the loader after
// add-note / record-recovery.

export interface TpsCollectionCase {
  id: string;
  loanId: string;
  loanNumber: string;
  borrowerName: string;
  status: string;
  triggeredBy: string | null;
  /** ISO timestamp. */
  triggerDate: string;
  originalExposure: number | null;
  grossRecovered: number;
  netRecovered: number;
}

export interface TpsCollectionRecovery {
  id: string;
  recoveryDate: string;
  recoverySource: string;
  grossAmount: number;
  recoveryCosts: number;
  netAmount: number;
  /** The fee booked to your Commissions for this recovery (record-only). */
  feeEarned: number;
}

export interface TpsCollectionEvent {
  id: string;
  eventCategory: string;
  eventSubtype: string;
  eventDate: string;
  description: string;
  dollarImpact: number | null;
}

export interface TpsCollectionCaseDetail {
  id: string;
  loanId: string;
  loanNumber: string;
  borrowerName: string;
  status: string;
  triggeredBy: string | null;
  triggerDate: string;
  description: string | null;
  currentRemediationLevel: string | null;
  originalExposure: number | null;
  grossRecovered: number;
  netRecovered: number;
  /** Your collection-recovery fee rate (fraction, e.g. 0.15 = 15%). */
  feeRate: number;
  feeEarnedTotal: number;
  recoveries: TpsCollectionRecovery[];
  timeline: TpsCollectionEvent[];
}

export interface RecordTpsCollectionRecoveryRequest {
  /** DateOnly "YYYY-MM-DD". */
  recoveryDate: string;
  recoverySource: string;
  grossAmount: number;
  recoveryCosts: number;
  depositAccount: string;
}

export const tpsCollectionsApi = {
  list: () => portalApi.get<TpsCollectionCase[]>("/tps/collections"),
  get: (caseId: string) =>
    portalApi.get<TpsCollectionCaseDetail>(`/tps/collections/${caseId}`),
  addNote: (caseId: string, note: string) =>
    portalApi.post<TpsCollectionCaseDetail>(`/tps/collections/${caseId}/notes`, { note }),
  recordRecovery: (caseId: string, body: RecordTpsCollectionRecoveryRequest) =>
    portalApi.post<TpsCollectionCaseDetail>(`/tps/collections/${caseId}/recoveries`, body),
};
